export default __webpack_public_path__ + "static/media/CreatePost.b8c04582.jpg";